import AssessmentController from '../assessments/assessment';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class _AssessmentController extends AssessmentController {
  @service
  router;

  @service
  session;

  @tracked
  editingPost = false;
  selectedModules = null;
  @tracked
  postBeingEdited = null;

  @action
  autoScroll(className) {
    // May have to set this up for safari browsers??
    let postBox = window.document.getElementsByClassName(className);
    window.document.documentElement.scrollTo({
      top: postBox[0].offsetTop - 50,
      behavior: 'smooth',
    });
  }

  @action
  newPost() {
    this.postBeingEdited = null;
    this.editingPost = true;
  }

  @action
  editPost(post) {
    this.editingPost = true;
    this.postBeingEdited = post;
  }

  @action
  closeEditPost() {
    this.editingPost = false;
    this.postBeingEdited = null;
    this.router.refresh('page.assessment');
  }
}
